export default {
    'add-new-product': 'Add new product',
    'category': 'Categories',
    'add-product': 'Add product',
    'edit-product': 'Edit product',
    'the-product': 'product data?',
    'product-is-added': 'product is added',
    'product-is-edited': 'product is edited',
    'this-product': 'this product'
}